// extracted by mini-css-extract-plugin
module.exports = {"FavouriteIndicator":"FavouriteIndicator_FavouriteIndicator__2iBnl"};